import type { LegalEntity } from "@/model/LegalEntity";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { getSelectedEntity, setSelectedEntity } from "@/store/user/userSlice";
import clsx from "clsx";
import { type ChangeEvent } from "react";

export const LegalEntitySelector = () => {
  const appDispatch = useAppDispatch();
  const classes = clsx('form-select');

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const v = event.target.value as LegalEntity
    appDispatch(setSelectedEntity(v))
  }

  const defaultValue = useAppSelector(getSelectedEntity) ?? 'LUX'

  return (
    <select
      className={classes}
      id={'legal-entity-selector'}
      onChange={handleChange}
      defaultValue={defaultValue}
      style={{ maxWidth: '12rem', marginRight: '1em' }}
    >
      <option value={'LUX'} key={'LUX'}>
        Luxembourg
      </option>
      <option value={'MCO'} key={'MCO'} >
        Monaco
      </option>
    </select>
  )
}